import { useEffect, useState } from "react"
import classNames from "classnames"

import { getWindowWidth } from "web/services/browser"
import { Icon } from "web/components"

const MOBILE_SCREEN_BREAKPOINT = 768

export default function Expander({ children }) {
  const [show, setShow] = useState(true)

  const handleResize = () => {
    const width = getWindowWidth()

    if (width > MOBILE_SCREEN_BREAKPOINT && !show) {
      setShow(true)
    }
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  })

  const spanClasses = classNames("md:hidden ml-auto m-2 p-2 rounded-md", {
    "bg-primary-10": show,
  })

  return (
    <span className="flex flex-col">
      <span
        className={spanClasses}
        onClick={() => {
          setShow(!show)
        }}
      >
        <Icon name="funnel" outline="true" />
      </span>
      {show && <span>{children}</span>}
    </span>
  )
}
